/**
 * @module lib/SmartConversionUtils
 */

import axios from 'axios';

import { SmartConversionKeys } from '../constants/SmartConversion';
import Logger from '../tools/Logger';

const log = Logger.child({ component: 'lib/SmartConversionUtils' });

export function getCurrentTrackingEvents(state: $TSFixMe): $TSFixMe {
  return state.smartConversion.get(SmartConversionKeys.TRACKING_EVENTS_KEY);
}

function hitTrackingUrl(url: string): $TSFixMe {
  axios({
    url,
  })
    .then(() => {
      log.info('SmartConversion: successfully hit tracking URL ' + url);
    })
    .catch(error => {
      log.error('SmartConversion: error hitting tracking URL; ' + error);
    });
}

export function hitTrackingUrls(urls: string[]): void {
  urls.forEach((url: $TSFixMe) => {
    hitTrackingUrl(url);
  });
}

export function isSmartConversionFlowActive(state: $TSFixMe): boolean {
  return !getCurrentTrackingEvents(state).isEmpty();
}

export function getSmartConversionHaymakerUrl(
  state: $TSFixMe,
): typeof SmartConversionKeys['HAYMAKER_URL_KEY'] {
  return state.smartConversion.get(SmartConversionKeys.HAYMAKER_URL_KEY);
}
